import React, { useState, useEffect } from 'react'
import { wizPageFive, wizPageFour, wizPageOne, wizPageThree, wizPageTwo } from '../../../assets';

const ImageProgressPage = (props) => {

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    switch (props.page) {
        case 1:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageOne} alt='wizPageOne' width='100%' />
                            :
                            <img src={wizPageOne} alt='wizPageOne' />
                    }
                </>
            );
        case 2:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageTwo} alt='wizPageTwo' width='100%' />
                            :
                            <img src={wizPageTwo} alt='wizPageTwo' />
                    }
                </>
            );
        case 3:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageThree} alt='wizPageThree' width='100%' />
                            :
                            <img src={wizPageThree} alt='wizPageThree' />
                    }
                </>
            );
        case 4:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageFour} alt='wizPageFour' width='100%' />
                            :
                            <img src={wizPageFour} alt='wizPageFour' />
                    }
                </>
            );
        case 4.5:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageFour} alt='wizPageFour' width='100%' />
                            :
                            <img src={wizPageFour} alt='wizPageFour' />
                    }
                </>
            );
        case 5:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageFive} alt='wizPageFive' width='100%' />
                            :
                            <img src={wizPageFive} alt='wizPageFive' />
                    }
                </>
            );
        case 6:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageFive} alt='wizPageFive' width='100%' />
                            :
                            <img src={wizPageFive} alt='wizPageFive' />
                    }
                </>
            );
        case 7:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageFive} alt='wizPageFive' width='100%' />
                            :
                            <img src={wizPageFive} alt='wizPageFive' />
                    }
                </>
            );
        case 8:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageFive} alt='wizPageFive' width='100%' />
                            :
                            <img src={wizPageFive} alt='wizPageFive' />
                    }
                </>
            );
        default:
            return (
                <>
                    {
                        size.width < 500 ?
                            <img src={wizPageOne} alt='wizPageOne' width='100%' />
                            :
                            <img src={wizPageOne} alt='wizPageOne' />
                    }
                </>
            );
    }
}

export default ImageProgressPage
